import { ActionButton, cn, Dialog } from "@eisox/design-system";
import { ArrowRightIcon, WarningIcon } from "@eisox/icons";
import { colors } from "@eisox/tokens";

import { m } from "~/paraglide/messages";

interface ConfirmCancelPopupProps {
  open: boolean;
  title?: string;
  className?: string;
  onClose?: VoidFunction;
  onValidate: VoidFunction;
}

export const ConfirmCancelPopup: React.FC<ConfirmCancelPopupProps> = ({
  open,
  title,
  className,
  onClose,
  onValidate,
}) => (
  <Dialog.Root open={open} onOpenChange={open => !open && onClose?.()}>
    <Dialog.Content
      className={className}
      title={title}
      icon={<WarningIcon color={colors.primary.red} className={cn("text-primary-red")} />}
    >
      <p>{m.unsaved_changes()}</p>
      <div className={cn("gap-2.5 flex justify-center")}>
        <ActionButton variant="cancel" onClick={onClose}>
          {m.back()}
        </ActionButton>
        <ActionButton onClick={onValidate}>
          {m.cancel_updates()}
          <ArrowRightIcon />
        </ActionButton>
      </div>
    </Dialog.Content>
  </Dialog.Root>
);
